exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_permissionsEditPanel_3ViaKBPSdOMGCY_5gA-T69 {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_hmcL9gojX_cwNUabHTInV {\n  position: relative;\n  float: left;\n  width: calc(100% - 40px);\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n\n.IA_permissionsSearchResult_1rzZNFRMRgRZAIBYNacih {\n  margin-top: 100px;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_permissionsEditPanel": "IA_permissionsEditPanel_3ViaKBPSdOMGCY_5gA-T69",
	"IA_content": "IA_content_hmcL9gojX_cwNUabHTInV",
	"IA_permissionsSearchResult": "IA_permissionsSearchResult_1rzZNFRMRgRZAIBYNacih"
};